import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
const endpoint = '/api/factibilidadSoporte';
const downloadEndpoint = '/api/factibilidadSoporte/download';

// Sube (o reemplaza si ya existe) el soporte de Factibilidad Actualizada de un proyecto
const createSoporte = async (formData) => {
  try {
    const response = await axios.post(`${baseUrl}${endpoint}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return { status: response.status, data: response.data };
  } catch (error) {
    return {
      status: error.response ? error.response.status : 500,
      message: error.response?.data?.message || 'Error al guardar el soporte',
    };
  }
};

const updateSoporte = async (oidProyecto, formData) => {
  try {
    const response = await axios.put(`${baseUrl}${endpoint}/${oidProyecto}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return { status: response.status, data: response.data };
  } catch (error) {
    return {
      status: error.response ? error.response.status : 500,
      message: error.response?.data?.message || 'Error al reemplazar el soporte',
    };
  }
};

// Consulta si el proyecto tiene un soporte activo. No lanza si no existe (404).
const getSoporte = async (oidProyecto) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/${oidProyecto}`);
    return { status: response.status, data: response.data };
  } catch (error) {
    if (error.response?.status === 404) {
      return { status: 404, data: null };
    }
    return { status: error.response ? error.response.status : 500, data: null };
  }
};

const deleteSoporte = async (oidProyecto, usuario) => {
  try {
    const response = await axios.delete(`${baseUrl}${endpoint}/${oidProyecto}`, {
      data: { usuario },
    });
    return { status: response.status, data: response.data };
  } catch (error) {
    return {
      status: error.response ? error.response.status : 500,
      message: error.response?.data?.message || 'Error al eliminar el soporte',
    };
  }
};

const downloadSoporte = async (oidProyecto, nombreSoporte) => {
  try {
    const response = await axios.get(`${baseUrl}${downloadEndpoint}/${oidProyecto}`, {
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nombreSoporte || 'Factibilidad_Actualizada.pdf');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { status: response.status, message: 'Archivo descargado correctamente' };
  } catch (error) {
    return { status: error.response ? error.response.status : 500, message: 'Error al descargar el archivo' };
  }
};

const viewSoporte = async (oidProyecto) => {
  try {
    const response = await axios.get(`${baseUrl}${downloadEndpoint}/${oidProyecto}`, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    window.open(url);
    return { status: response.status, message: 'Archivo abierto correctamente' };
  } catch (error) {
    return { status: error.response ? error.response.status : 500, message: 'Error al abrir el archivo' };
  }
};

export { createSoporte, updateSoporte, getSoporte, deleteSoporte, downloadSoporte, viewSoporte };
